module.exports = __webpack_public_path__ + "media/images/icon-hamburger.black-165ad27b706e0673aac43d5bbc8cf1e7.svg";